import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { name: "CreateEditNotice" }
const _hoisted_2 = { class: "vstack gap-3" }

import {ref, computed, watch, onMounted} from "vue";
import {Death, DeathForm, DeathZeroReport} from "./schema";
import {useDcraStore} from "@/stores/dcraStore";
import FormModal from "../Misc/FormModal.vue";
import SelectField from "@/components/Misc/SelectField.vue";
import {BInput, BTextarea, BAgency, BDatePicker} from "@/components/Fields";
import {array, date, number, object, string, ValidationError} from "yup";
import {useFormValidation} from "@/validation";
import {SelectItem, UploadType} from "@/types";

const title = "Add Zero Report";

export default /*@__PURE__*/_defineComponent({
  __name: 'AddZeroReport',
  props: /*@__PURE__*/_mergeModels({
    startDate: {}
  }, {
    "modelValue": {type: Boolean},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["dismiss", "submit", "update:modelValue"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const modelValue = _useModel(__props, "modelValue");
const props = __props;
const emit = __emit;
var dcraStore = useDcraStore();

const {handleSubmit, errors, resetValidation} = useFormValidation();

const form = ref({
    agency: "",
    year: new Date().getFullYear(),
    quarter: 0,
} as DeathZeroReport);

const schema = object<DeathForm>({
    agency: string().required("Agency is a required field"),
    year: number()
        .transform((value) => (Number.isNaN(value) ? null : value))
        .min(new Date(props.startDate).getFullYear())
        .max(new Date().getFullYear())
        .required("Year is a required field"),
    quarter: number().required("Quarter is a required field"),
});

var dcraErrors = ref([] as string[]);

var dcraOris = ref([] as SelectItem[]);
var quarters = ref([] as SelectItem[]);
//Computed

const years = computed(()=> {
    let years = [] as SelectItem[];

    for(var i = new Date(props.startDate).getFullYear(); i<= new Date().getFullYear(); i++ ){
        years.push({label: `${i}`, value: i} as SelectItem)
    }

    return years;
})
//FUNctions
const getQuarters = () => {    
    quarters.value = [] as SelectItem[];
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();

    const currentQuarter = Math.floor(currentMonth / 3) + 1;

    if (form.value.year < currentYear) {
        quarters.value =  [
            {label: "Q1", value: 1},
            {label: "Q2", value: 2},
            {label: "Q3", value: 3},
            {label: "Q4", value: 4},
        ] as SelectItem[];
    }

    if (form.value.year === currentYear) {
        quarters.value = Array.from({length: currentQuarter}, (_, i) => {
            return {label: `Q${i + 1}`, value: i + 1} as SelectItem;
        });
    };
};

const submitForm = async () => {
    if (await handleSubmit(schema, form.value)) {
        await dcraStore.addZeroReport(form.value);

        window.location.href = "dataupload.aspx?source=8";
    }
};

const handleYearUpdate = () => {
    form.value.quarter = -1;
    getQuarters();
}

const getOriList = async () => {
    let data = await dcraStore.getOriListForDataset("DCRA");

    dcraOris.value = data.map(ori=> {
        return {label:`${ori.ori} - ${ori.label}`, value:ori.ori} as SelectItem;
    });
}
//LifeCycle Hooks
onMounted(async () => {
    await getOriList();

    getQuarters();
});

watch(
    () => form.value,
    async () => {
        
        try {
            if (errors.value.length == 0) {
                return;
            }

            errors.value = Array.isArray(errors.value) ? [] : {};
            await schema.validate(form.value, {abortEarly: false});
        } catch (err) {
            const error = err as ValidationError;
            if (error.name !== "ValidationError") throw err;

            // Build an object map of field -> message
            const newErrors: Record<string, string> = {};
            error.inner.forEach((it: ValidationError) => {
                if (it.path) newErrors[it.path] = it.message;
            });
            errors.value = newErrors;
        }
    },
    {deep: true}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(FormModal, {
      title: title,
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue).value = $event)),
      "submit-button": 'Submit',
      onSubmit: submitForm
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { for: "agency" }, "Agency *", -1)),
            _createVNode(SelectField, {
              name: "agency",
              class: "w-100",
              modelValue: form.value.agency,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.agency) = $event)),
              "select-items": _unref(dcraOris),
              mode: "single",
              error: _unref(errors).agency,
              min: 1
            }, null, 8, ["modelValue", "select-items", "error"])
          ]),
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "year" }, "Year *", -1)),
            _createVNode(SelectField, {
              name: "year",
              class: "w-100",
              modelValue: form.value.year,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((form.value.year) = $event)),
                _cache[2] || (_cache[2] = ($event: any) => (handleYearUpdate()))
              ],
              "select-items": years.value,
              mode: "single",
              error: _unref(errors).year,
              min: 1
            }, null, 8, ["modelValue", "select-items", "error"])
          ]),
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "quarter" }, "Quarter *", -1)),
            _createVNode(SelectField, {
              name: "quarter",
              class: "w-100",
              modelValue: form.value.quarter,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.quarter) = $event)),
              "select-items": _unref(quarters),
              mode: "single",
              error: _unref(errors).quarter,
              min: 1,
              "open-direction": 'top'
            }, null, 8, ["modelValue", "select-items", "error"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})